import React from "react"
import {FieldManagementFormProps} from "../../render/management-form";

export default function FieldProto_ManagementForm(props:FieldManagementFormProps) {

    return (
        <div className="ui5-txt-default ui5-txt-red">{props.field.type}.managementForm</div>
    )

}